import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { IoDocumentsOutline, IoMenu, IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";

const SubPart = () => {

    const { id } = useParams();
    const store = useSelector((state) => state.auth.discloser);

    const [openId, setOpenId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [defaultYear, setDefaultYear] = useState("2026");

    const filteredMainParts = store.filter(part =>
        part.categoryName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const selectedMainPart = store.find(
        p => p.categoryId === Number(id)
    );

    const toggle = (subId) => {
        setOpenId(prev => prev === subId ? null : subId);
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(prev => !prev);
    };

    const handleMenuItemClick = () => {
        if (isMobile) setIsSidebarOpen(false);
    };

    useEffect(() => {

        const handleResize = () => {

            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);

            if (!mobile) {
                setIsSidebarOpen(false);
            }

        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);

    }, []);

    return (

        <div style={styles.app}>

            {isMobile && (

                <div style={styles.mobileHeader}>

                    <button onClick={toggleSidebar} style={styles.menuButton}>
                        {isSidebarOpen ? <IoClose size={24} /> : <IoMenu size={24} />}
                    </button>

                    <h2 style={styles.mobileTitle}>
                        {selectedMainPart
                            ? selectedMainPart.categoryName.substring(0, 20) +
                            (selectedMainPart.categoryName.length > 20 ? "..." : "")
                            : "Main Parts"}
                    </h2>

                </div>

            )}

            <div
                style={{
                    ...styles.sidebar,
                    ...(isMobile
                        ? {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            bottom: 0,
                            zIndex: 1000,
                            transform: isSidebarOpen
                                ? "translateX(0)"
                                : "translateX(-100%)",
                            transition: "transform 0.3s ease-in-out",
                            width: "280px",
                        }
                        : {}),
                }}
            >

                <div style={styles.sidebarHeader}>

                    <h2 style={styles.sidebarTitle}>Disclosers</h2>

                    <input
                        type="text"
                        placeholder="Search..."
                        style={styles.searchInput}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />

                </div>

                <div style={styles.menuList}>

                    {filteredMainParts.map((part) => (

                        <Link
                            key={part.categoryId}
                            to={`/data/${part.categoryId}/${part.categoryName
                                .toLowerCase()
                                .split(" ")
                                .join("-")}`}
                            style={{
                                ...styles.menuItem,
                                ...(Number(id) === part.categoryId
                                    ? styles.activeMenuItem
                                    : {}),
                                textDecoration: "none",
                            }}
                            onClick={handleMenuItemClick}
                        >

                            <span style={styles.menuText}>
                                {part.categoryName}
                            </span>

                        </Link>

                    ))}

                </div>

            </div>

            {isMobile && isSidebarOpen && (
                <div style={styles.overlay} onClick={toggleSidebar} />
            )}

            <div
                style={{
                    ...styles.content,
                    ...(isMobile ? { padding: "16px", marginTop: "60px" } : {}),
                }}
            >

                <div style={styles.contentHeader}>

                    <h1
                        style={{
                            ...styles.mainTitle,
                            ...(isMobile ? { fontSize: "1.5rem" } : {}),
                        }}
                    >

                        {selectedMainPart
                            ? selectedMainPart.categoryName
                            : "Select a Part"}

                    </h1>

                </div>

                {selectedMainPart ? (

                    <div style={styles.cardsContainer}>

                        {selectedMainPart.subcategories.map((item) => {

                            const yearData = item.years?.find(
                                (year) => year.yearId === Number(defaultYear)
                            );

                            return (

                                <div key={item.subCategoryId} style={styles.card}>

                                    <div
                                        style={styles.cardHeader}
                                        onClick={() => toggle(item.subCategoryId)}
                                    >

                                        <div style={styles.cardTitleSection}>

                                            <h3
                                                style={{
                                                    ...styles.cardTitle,
                                                    ...(isMobile
                                                        ? { fontSize: "1.3rem" }
                                                        : {}),
                                                }}
                                            >

                                                {item.subCategoryName}

                                            </h3>

                                        </div>

                                        <span
                                            style={{
                                                ...styles.expandIcon,
                                                ...(isMobile
                                                    ? { fontSize: "1.5rem" }
                                                    : {}),
                                            }}
                                        >

                                            {openId === item.subCategoryId
                                                ? "−"
                                                : "+"}

                                        </span>

                                    </div>

                                    {openId === item.subCategoryId && (

                                        <div style={styles.expandedContent}>

                                            <div style={styles.yearFilter}>

                                                <label style={styles.yearLabel}>
                                                    Choose Year
                                                </label>

                                                <select
                                                    value={defaultYear}
                                                    onChange={(e) =>
                                                        setDefaultYear(
                                                            e.target.value
                                                        )
                                                    }
                                                    style={styles.yearSelect}
                                                >

                                                    <option value="2026">2026</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2024">2024</option>

                                                </select>

                                            </div>

                                            {yearData ? (

                                                <div
                                                    style={
                                                        isMobile
                                                            ? { overflowX: "auto" }
                                                            : {}
                                                    }
                                                >

                                                    <table
                                                        style={{
                                                            ...styles.table,
                                                            ...(isMobile
                                                                ? styles.mobileTable
                                                                : {}),
                                                        }}
                                                    >

                                                        <thead>

                                                            <tr>

                                                                <th style={styles.tableHeader}>Sr no</th>
                                                                <th style={styles.tableHeader}>Years</th>
                                                                <th style={styles.tableHeader}>Month</th>
                                                                <th style={styles.tableHeader}>Documents</th>

                                                            </tr>

                                                        </thead>

                                                        <tbody>

                                                            {yearData.months?.map((doc, index) => (

                                                                <tr key={index} style={styles.tableRow}>

                                                                    <td style={styles.tableCell}>
                                                                        {index + 1}
                                                                    </td>

                                                                    <td style={styles.tableCell}>
                                                                        {yearData.yearId}
                                                                    </td>

                                                                    <td style={styles.tableCell}>
                                                                        {doc.monthName}
                                                                    </td>

                                                                    <td style={styles.tableCell}>

                                                                        <a
                                                                            href={doc.data?.[0]?.evidance}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={styles.documentButton}
                                                                        >

                                                                            <IoDocumentsOutline style={styles.buttonIcon} />

                                                                            <span
                                                                                style={
                                                                                    isMobile
                                                                                        ? { display: "none" }
                                                                                        : {}
                                                                                }
                                                                            >

                                                                                Document

                                                                            </span>

                                                                        </a>

                                                                    </td>

                                                                </tr>

                                                            ))}

                                                        </tbody>

                                                    </table>

                                                </div>

                                            ) : (

                                                <p style={styles.noDocuments}>
                                                    No documents uploaded
                                                </p>

                                            )}

                                        </div>

                                    )}

                                </div>

                            );

                        })}

                    </div>

                ) : (

                    <div style={styles.emptyState}>
                        <p>
                            Select a part from the sidebar to view details
                        </p>
                    </div>

                )}

            </div>

        </div>

    );
};



const styles = {
    app: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        position: 'relative',
    },
    mobileHeader: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '60px',
        backgroundColor: '#1e293b',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        zIndex: 999,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    menuButton: {
        background: 'none',
        border: 'none',
        color: '#fff',
        cursor: 'pointer',
        padding: '8px',
        marginRight: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    mobileTitle: {
        margin: 0,
        fontSize: '1.1rem',
        fontWeight: '500',
        color: '#fff',
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 999,
    },
    yearFilter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "14px",
        marginBottom: "18px",
        background: "#fff",
        padding: "12px 14px",
        borderRadius: "10px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        flexWrap: "wrap",
    },
    yearLabel: {
        fontWeight: "600",
        fontSize: "14px",
        color: "#334155",
    },
    yearSelect: {
        padding: "10px 14px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1",
        background: "#f8fafc",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer",
        outline: "none",
        transition: "all .2s ease",
        minWidth: "120px",
    },
    sidebar: {
        width: '350px',
        backgroundColor: '#1e293b',
        color: '#fff',
        overflowY: 'auto',
        boxShadow: '2px 0 8px rgba(0,0,0,0.1)',

        // ✅ ADD THIS
        position: 'sticky',
        top: 0,
        height: '100vh',
    },
    sidebarHeader: {
        padding: '24px 20px',
        borderBottom: '1px solid #334155',
    },
    sidebarTitle: {
        margin: '0 0 16px 0',
        fontSize: '1.25rem',
        fontWeight: '600',
        color: '#fff',
    },
    searchInput: {
        width: '100%',
        padding: '10px 12px',
        borderRadius: '8px',
        border: '1px solid #475569',
        backgroundColor: '#334155',
        color: '#fff',
        fontSize: '0.9rem',
        outline: 'none',
        '::placeholder': {
            color: '#94a3b8',
        },
    },
    menuList: {
        padding: '16px 0',
    },
    menuItem: {
        display: 'block',
        padding: '12px 20px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        color: '#cbd5e1',
        ':hover': {
            backgroundColor: '#334155',
            color: '#fff',
        },
    },
    activeMenuItem: {
        backgroundColor: '#3b82f6',
        color: '#fff',
        borderLeft: '4px solid #60a5fa',
    },
    menuText: {
        fontSize: '1.5rem',
        fontWeight: '500',
        lineHeight: '1.4',
        display: 'block',
    },
    content: {
        flex: 1,
        padding: '32px',
        overflowY: 'auto',
    },
    contentHeader: {
        marginBottom: '32px',
    },
    mainTitle: {
        margin: 0,
        fontSize: '2rem',
        fontWeight: '600',
        color: '#1e293b',
    },
    cardsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
    },
    cardHeader: {
        padding: '16px 20px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#fff',
        transition: 'background-color 0.2s',
        ':hover': {
            backgroundColor: '#f8fafc',
        },
    },
    cardTitleSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flex: 1,
    },
    cardTitle: {
        margin: 0,
        fontSize: '1.9rem',
        fontWeight: '600',
        color: '#1e293b',
    },
    expandIcon: {
        fontSize: '3rem',
        color: '#64748b',
        fontWeight: '300',
        marginLeft: '16px',
    },
    cardContent: {
        padding: '0 20px 16px 20px',
    },
    description: {
        margin: 0,
        color: '#4b5563',
        fontSize: '1.2rem',
        lineHeight: '1.5',
    },
    expandedContent: {
        padding: '20px',
        backgroundColor: '#f8fafc',
        borderTop: '1px solid #e5e7eb',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        backgroundColor: '#fff',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    mobileTable: {
        minWidth: '500px',
    },
    tableHeader: {
        padding: '12px',
        textAlign: 'left',
        backgroundColor: '#f1f5f9',
        color: '#475569',
        fontWeight: '600',
        fontSize: '1.4rem',
        borderBottom: '2px solid #e2e8f0',
    },
    tableRow: {
        borderBottom: '1px solid #e2e8f0',
        ':hover': {
            backgroundColor: '#f8fafc',
        },
    },
    tableCell: {
        padding: '12px',
        color: '#334155',
        fontSize: '1.2rem',
    },
    documentButton: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 12px',
        backgroundColor: '#3b82f6',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        fontSize: '0.85rem',
        fontWeight: '500',
        cursor: 'pointer',
        textDecoration: 'none',
        transition: 'background-color 0.2s',
        ':hover': {
            backgroundColor: '#2563eb',
        },
    },
    buttonIcon: {
        fontSize: '1.5rem',
    },
    noDocuments: {
        color: '#6b7280',
        fontStyle: 'italic',
        margin: 0,
        padding: '12px',
        textAlign: 'center',
    },
    emptyState: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        color: '#6b7280',
        fontSize: '1rem',
        backgroundColor: '#fff',
        borderRadius: '12px',
        border: '2px dashed #e5e7eb',
        padding: '20px',
        textAlign: 'center',
    },
};

export default SubPart;